import Button from "../Button";
import PropTypes from "prop-types";
import FinishIcon from "./FinishIcon";
import ArrowForward from "./ArrowForwardIcon";
import ArrowBack from "./ArrowBackIcon";
import classes from "./Navigation.module.scss";
import clsx from "clsx";
import { motion, useAnimate } from "framer-motion";
import { useTranslate } from "@educaplay/core/hooks";
import { forwardRef, useImperativeHandle } from "react";

const Navigation = forwardRef(function Navigation(props, ref) {
    const { onPrev, onNext, onFinish, showFinish, freeze, disabledPrev, disabledNext, className } = props;
    const t = useTranslate();

    const [containerRef, animate] = useAnimate();

    useImperativeHandle(ref, () => ({
        animateEntry: async () => {
            await animate(containerRef.current, { opacity: 1 }, { duration: .5 })
        },
      }));

    return (
        <motion.div ref={containerRef} style={{ opacity: 0}} className={clsx(classes.nav, freeze && classes.freeze, className)}>
            <Button
                Icon={ArrowBack}
                onClick={onPrev}
                disabled={disabledPrev}
                label={t("specific.previous")}
            />
            <Button
                Icon={ArrowForward}
                disabled={disabledNext}
                onClick={onNext}
                label={t("specific.next")}
            />

            {showFinish && (
                  <div className={classes.floatRight}>
                    <motion.div
                        style={{ opacity: 0, x: -10}}
                        animate={{ opacity: 1, x: 0}}
                    >
                    <Button
                        onClick={onFinish}
                        Icon={FinishIcon}
                        label={t("specific.finish")}
                        variant="primary"
                        size="large"
                        />
                    </motion.div>
                </div>
            )}
        </motion.div>
    )
});

export default Navigation;

Navigation.propTypes = {
    onPrev: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    showFinish: PropTypes.bool,
    disabledPrev: PropTypes.bool,
    disabledNext: PropTypes.bool,
    freeze: PropTypes.bool,
    className: PropTypes.string,
}